enum ProductTypes {
  Deposits = 'vklady',
  BusinessCredit = 'biznes-kredity',
  BusinessRKO = 'biznes-rko',
  BankGuarantees = 'bankovskie-garantii',
  BusinessAcquiring = 'biznes-ekvajring',
  BusinessVed = 'biznes-ved',
  BusinessAccounting = 'biznes-accounting',
  BusinessDeposit = 'biznes-depozit',
  BusinessRegistration = 'biznes-registration',
  Mortgage = 'ipoteka',
  Credits = 'kredity',
  BusinessMarketplace = 'biznes-marketplace',
  CreditCards = 'credit-cards',
  Bankruptcy = 'bankrotstvo',
  DebitCards = 'debit-cards',
  BusinessLeasing = 'biznes-leasing',
  SalaryProject = 'salary-project',
  Appraisal = 'ocenka-nedvizhimosti',
  InvestDeposits = 'invest-vklady',
  Bookmaker = 'bukmekery',
  Pds = 'pds-programmy',
}

export default ProductTypes;
